var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArgencoPijlOutlineGreenRgb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 595.3 841.9",
    style: {
      enableBackground: "new 0 0 595.3 841.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#145459;stroke-width:2.8346;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M389.6,411.8h152.2c20.6,0,30.8-24,16.1-37.8L314.2,144.3c-8.9-8.4-23.3-8.4-32.2,0L38.3,374 c-14.7,13.8-4.5,37.8,16.1,37.8h152.2c13.7,0,20.5,16,10.7,25.2L102,545.6c-14.7,13.8-4.5,37.8,16.1,37.8h102.7 c13.7,0,20.5,16,10.7,25.2l-62,58.5c-14.7,13.8-4.5,37.8,16.1,37.8h225c20.6,0,30.8-24,16.1-37.8l-62-58.5 c-9.8-9.2-3-25.2,10.7-25.2h102.7c20.6,0,30.8-24,16.1-37.8L378.9,437C369.1,427.7,375.9,411.8,389.6,411.8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArgencoPijlOutlineGreenRgb);
export default __webpack_public_path__ + "static/media/Argenco_pijl_outline_green_rgb.fbc5de64717987a27581efa08645c64a.svg";
export { ForwardRef as ReactComponent };